import { Box, Paper, Skeleton } from "@mui/material";
import type { FC } from "react";

/** One notification card's placeholder while the list loads — the shape of a `NotificationItem`. */
export const NotificationSkeleton: FC = () => (
	<Paper elevation={0} sx={{ width: "100%", p: 2, borderRadius: 2 }}>
		<Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
			<Box sx={{ flex: 1 }}>
				<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
					<Skeleton variant="text" width={120} height={24} />
					<Skeleton variant="circular" width={24} height={24} />
				</Box>
				<Skeleton variant="text" width="40%" height={20} />
				<Box sx={{ mt: 1, display: "flex", gap: 1 }}>
					<Skeleton variant="rounded" width={100} height={24} />
					<Skeleton variant="rounded" width={100} height={24} />
				</Box>
			</Box>
			<Skeleton variant="rounded" width={80} height={24} />
		</Box>
	</Paper>
);
